"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentFormatEnum = void 0;
var DocumentFormatEnum;
(function (DocumentFormatEnum) {
  DocumentFormatEnum["other"] = "other";
  DocumentFormatEnum["msdoc"] = "msdoc";
  DocumentFormatEnum["msxls"] = "msxls";
  DocumentFormatEnum["msppt"] = "msppt";
  DocumentFormatEnum["pdf"] = "pdf";
  DocumentFormatEnum["odt"] = "odt";
  DocumentFormatEnum["rtf"] = "rtf";
})(DocumentFormatEnum = exports.DocumentFormatEnum || (exports.DocumentFormatEnum = {}));
